import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getCertificateDetails } from 'modules/activityDetails/CertificateDetails/api/certificateDetailsService'
import { CertificateDetailsState, ApiCertificateDetailsResponse } from './types'

const initialState: CertificateDetailsState = {
  certificateDetailsData: {},
}

const certificateDetailsSlice = createSlice({
  name: 'certificateDetails',
  initialState,
  reducers: {
    certificateDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiCertificateDetailsResponse>>
    ) {
      state.certificateDetailsData = action.payload
    },
    clearCertificateDetails(state) {
      state.certificateDetailsData = initialState.certificateDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { certificateDetailsLoaded, clearCertificateDetails } = certificateDetailsSlice.actions

export { clearCertificateDetails }
export default certificateDetailsSlice.reducer

export const loadCertificateDetailsData = (certificateId: Guid, resultId?: Guid) => {
  return createApiAction({
    apiCalls: {
      certificateDetails: () => getCertificateDetails(certificateId, resultId),
    },
    payloadAction: certificateDetailsLoaded,
    getResultToKeep: state => state.certificateDetails.certificateDetailsData.result,
  })
}
